import { Menu, MenuItem } from "@alternative/components";
import { IconNames } from "@alternative/icons";
import { ContextMenu } from "@blueprintjs/core";
import React from "react";

const FmContextMenu = (props) => {
  const {
    handleCopy,
    handleCut,
    handlePaste,
    handleDelete,
    handleMoveToInternal,
    pasteEnabled = true,
    deleteEnabled = true,
    copyEnabled = true,
    cutEnabled = true,
    movetoInternalEnabled = false,
  } = props;

  return (
    <Menu>
      <MenuItem
        disabled={!cutEnabled}
        icon={IconNames.CUT}
        text="Cut"
        onClick={(e) => {
          ContextMenu.hide();
          if (!cutEnabled) return;
          if (handleCut) handleCut(e);
        }}
      />
      <MenuItem
        disabled={!copyEnabled}
        icon={IconNames.COPY}
        text="Copy"
        onClick={(e) => {
          ContextMenu.hide();
          if (!copyEnabled) return;
          if (handleCopy) handleCopy(e);
        }}
      />
      <MenuItem
        disabled={!pasteEnabled}
        icon={IconNames.PASTE}
        text="Paste"
        onClick={(e) => {
          ContextMenu.hide();
          if (!pasteEnabled) return;
          if (handlePaste) handlePaste(e);
        }}
      />
      <MenuItem
        disabled={!deleteEnabled}
        icon={IconNames.DELETE}
        text="Delete"
        onClick={(e) => {
          ContextMenu.hide();
          if (!deleteEnabled) return;
          if (handleDelete) handleDelete(e);
        }}
      />
      {movetoInternalEnabled && (
        <MenuItem
          disabled={!movetoInternalEnabled}
          text="Move to Internal"
          onClick={(e) => {
            ContextMenu.hide();
            if (!movetoInternalEnabled) return;
            if (handleMoveToInternal) handleMoveToInternal(e);
          }}
        />
      )}
    </Menu>
  );
};

export default FmContextMenu;
